import { gql } from '@apollo/client';
import { reviewIntegrationFragments } from './hospitals';

export const fragments = {
  small: gql`
    fragment SurgeonOfficeHospitalDataS on Hospital {
      id
      name
      address
      contact
      voidedAt
    }
  `,
  all: gql`
    fragment SurgeonOfficeHospitalData on Hospital {
      id
      name
      address
      contact
      notes
      voidedAt
      monitors {
        id
        name
      }
      groupAdmins {
        id
        name
      }
      sessionTimeout
      questionnaireValidMonths
      passwordRefreshDays
      reviewIntegrations {
        google {
          ...ReviewBase
        }
        yelp {
          ...ReviewBase
        }
      }
      timezone {
        id
        name
        offset
      }
      exchangeOnly
      covidScreening {
        id
        question
      }
      locations {
        id
        name
      }
    }
    ${reviewIntegrationFragments.base}
  `,
};

export const list = gql`
  query surgeonOffices($includeVoided: Boolean) {
    surgeonOffices(includeVoided: $includeVoided) {
      ...SurgeonOfficeHospitalDataS
    }
  }
  ${fragments.small}
`;

export const item = gql`
  query surgeonOffice($id: Long!) {
    surgeonOffice(id: $id) {
      ...SurgeonOfficeHospitalData
    }
  }
  ${fragments.all}
`;

export const create = gql`
  mutation createSurgeonOffice(
    $name: String!
    $address: String
    $contact: String
    $notes: String
    $sessionTimeout: Int!
    $questionnaireValidMonths: Int!
    $passwordRefreshDays: Int
    $reviewIntegrations: ReviewIntegrationsInput
    $timezone: String
    $exchangeOnly: Boolean
  ) {
    createSurgeonOffice(
      name: $name
      address: $address
      contact: $contact
      notes: $notes
      sessionTimeout: $sessionTimeout
      questionnaireValidMonths: $questionnaireValidMonths
      passwordRefreshDays: $passwordRefreshDays
      reviewIntegrations: $reviewIntegrations
      timezone: $timezone
      exchangeOnly: $exchangeOnly
    ) {
      ...SurgeonOfficeHospitalData
    }
  }
  ${fragments.all}
`;

export const update = gql`
  mutation editSurgeonOffice(
    $id: Long!
    $name: String
    $address: String
    $contact: String
    $notes: String
    $sessionTimeout: Int!
    $questionnaireValidMonths: Int!
    $passwordRefreshDays: Int
    $reviewIntegrations: ReviewIntegrationsInput
    $timezone: String
    $exchangeOnly: Boolean
  ) {
    editSurgeonOffice(
      id: $id
      name: $name
      address: $address
      contact: $contact
      notes: $notes
      sessionTimeout: $sessionTimeout
      questionnaireValidMonths: $questionnaireValidMonths
      passwordRefreshDays: $passwordRefreshDays
      reviewIntegrations: $reviewIntegrations
      timezone: $timezone
      exchangeOnly: $exchangeOnly
    ) {
      ...SurgeonOfficeHospitalData
    }
  }
  ${fragments.all}
`;

export const remove = gql`
  mutation deleteSurgeonOffice($id: Long!) {
    deleteSurgeonOffice(id: $id)
  }
`;

export const restoreSurgeonOffice = gql`
  mutation restoreSurgeonOffice($id: Long!) {
    restoreSurgeonOffice(id: $id)
  }
`;

export default {
  list,
  item,
  create,
  update,
  remove,
};
